import { render, staticRenderFns } from "./Bag_outline.vue?vue&type=template&id=2b8880e3&"
import script from "./Bag_outline.vue?vue&type=script&lang=js&"
export * from "./Bag_outline.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports